// @flow

import * as React from 'react';

import { Base, Placeholder } from '@gandi/ui';

import styles from './ShapedPlaceholder.scss';

type Props = {|
  children: React.Node,
|};

function ShapedPlaceholder({ children }: Props): React.Element<typeof Base> {
  return (
    <Base position="relative">
      {children}
      <Placeholder className={styles.placeholder} />
    </Base>
  );
}

export default ShapedPlaceholder;
